import { gql } from 'graphql-tag';

export const GET_PAYABLES_GROUPS = gql`
  query Id4d62bb378f299fd1d98a3b06e0e0d144(
    $companyId: ID!
    $after: ID
    $groupBy: PayableGroupBy!
    $filtersV2: JSON
    $textualSearch: String
  ) {
    __typename
  }
`;
